import { render, staticRenderFns } from "./GameLobbyView.vue?vue&type=template&id=f558a1b8"
import script from "./GameLobbyView.vue?vue&type=script&lang=js"
export * from "./GameLobbyView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f558a1b8')) {
      api.createRecord('f558a1b8', component.options)
    } else {
      api.reload('f558a1b8', component.options)
    }
    module.hot.accept("./GameLobbyView.vue?vue&type=template&id=f558a1b8", function () {
      api.rerender('f558a1b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/lobbies/GameLobbyView.vue"
export default component.exports